import _defineProperty from "/tmp/builds/n85FxqY8/0/kreezus/calendar/calendar-api/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/tmp/builds/n85FxqY8/0/kreezus/calendar/calendar-api/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/tmp/builds/n85FxqY8/0/kreezus/calendar/calendar-api/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/tmp/builds/n85FxqY8/0/kreezus/calendar/calendar-api/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/tmp/builds/n85FxqY8/0/kreezus/calendar/calendar-api/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { AppointmentStatus } from '@prisma/client';
import axios from 'axios';
import api from './api';

var AppointmentService = /*#__PURE__*/function () {
  function AppointmentService() {
    _classCallCheck(this, AppointmentService);
  }

  _createClass(AppointmentService, [{
    key: "getAppointment",
    value: function () {
      var _getAppointment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(idUser) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", api.get("users/".concat(idUser, "/appointments")).then(function (response) {
                  return {
                    success: true,
                    response: response
                  };
                })["catch"](function (err) {
                  return {
                    success: false,
                    response: err.response
                  };
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function getAppointment(_x) {
        return _getAppointment.apply(this, arguments);
      }

      return getAppointment;
    }()
  }, {
    key: "getAppointmentsForCalendar",
    value: function () {
      var _getAppointmentsForCalendar = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(idUser) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", api.get("users/".concat(idUser, "/appointments")).then(function (response) {
                  return response.data;
                })["catch"](function (err) {
                  return {
                    success: false,
                    response: err.response
                  };
                }));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function getAppointmentsForCalendar(_x2) {
        return _getAppointmentsForCalendar.apply(this, arguments);
      }

      return getAppointmentsForCalendar;
    }()
  }, {
    key: "postAppointment",
    value: function () {
      var _postAppointment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(baseUrl, calendarTypeId, appointment, guestTimezone) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", fetch("".concat(baseUrl, "/calendar-types/").concat(calendarTypeId, "/appointments"), {
                  headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                  },
                  method: 'POST',
                  body: JSON.stringify(_objectSpread(_objectSpread({}, appointment), {}, {
                    status: AppointmentStatus.ACCEPTED
                  }))
                }).then( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(response) {
                    var responseBody;
                    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            _context3.next = 2;
                            return response.json();

                          case 2:
                            responseBody = _context3.sent;

                            if (!response.ok) {
                              _context3.next = 5;
                              break;
                            }

                            return _context3.abrupt("return", responseBody);

                          case 5:
                            return _context3.abrupt("return", Promise.reject(responseBody));

                          case 6:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3);
                  }));

                  return function (_x7) {
                    return _ref.apply(this, arguments);
                  };
                }()));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function postAppointment(_x3, _x4, _x5, _x6) {
        return _postAppointment.apply(this, arguments);
      }

      return postAppointment;
    }()
  }, {
    key: "getOneAppointment",
    value: function () {
      var _getOneAppointment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(appointmentId) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return api.get("appointments/".concat(appointmentId)).then(function (response) {
                  return response;
                });

              case 2:
                return _context5.abrupt("return", _context5.sent);

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function getOneAppointment(_x8) {
        return _getOneAppointment.apply(this, arguments);
      }

      return getOneAppointment;
    }()
  }, {
    key: "updateAppointment",
    value: function () {
      var _updateAppointment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(baseUrl, calendarId, appointmentId, data, timeZone) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", fetch("".concat(baseUrl, "/calendar-types/").concat(calendarId, "/appointments/").concat(appointmentId, "?timeZone=").concat(timeZone), {
                  headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                  },
                  method: 'PATCH',
                  body: JSON.stringify(data)
                }).then( /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(response) {
                    var responseBody;
                    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            _context6.next = 2;
                            return response.json();

                          case 2:
                            responseBody = _context6.sent;

                            if (!response.ok) {
                              _context6.next = 5;
                              break;
                            }

                            return _context6.abrupt("return", responseBody);

                          case 5:
                            return _context6.abrupt("return", Promise.reject(responseBody));

                          case 6:
                          case "end":
                            return _context6.stop();
                        }
                      }
                    }, _callee6);
                  }));

                  return function (_x14) {
                    return _ref2.apply(this, arguments);
                  };
                }()));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function updateAppointment(_x9, _x10, _x11, _x12, _x13) {
        return _updateAppointment.apply(this, arguments);
      }

      return updateAppointment;
    }()
  }, {
    key: "cancelinkAppointment",
    value: function () {
      var _cancelinkAppointment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(appointmentId) {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", api.patch("appointments/".concat(appointmentId)).then(function (response) {
                  return {
                    success: true,
                    response: response
                  };
                })["catch"](function (err) {
                  return {
                    success: false,
                    response: err.response
                  };
                }));

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      function cancelinkAppointment(_x15) {
        return _cancelinkAppointment.apply(this, arguments);
      }

      return cancelinkAppointment;
    }()
  }, {
    key: "rejectAppointment",
    value: function () {
      var _rejectAppointment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(appointmentId) {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                return _context9.abrupt("return", api.patch("appointments/".concat(appointmentId, "/reject")).then(function (response) {
                  return {
                    success: true,
                    response: response
                  };
                })["catch"](function (err) {
                  return {
                    success: false,
                    response: err.response
                  };
                }));

              case 1:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      function rejectAppointment(_x16) {
        return _rejectAppointment.apply(this, arguments);
      }

      return rejectAppointment;
    }()
  }, {
    key: "onFileUploadBucket",
    value: function () {
      var _onFileUploadBucket = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(baseUrl, calendarId, file) {
        var formData;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                formData = new FormData();
                formData.append('files', file);
                return _context10.abrupt("return", axios.post("".concat(baseUrl, "/calendar-types/").concat(calendarId, "/appointments/upload"), formData).then(function (res) {
                  return res.data;
                }));

              case 3:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));

      function onFileUploadBucket(_x17, _x18, _x19) {
        return _onFileUploadBucket.apply(this, arguments);
      }

      return onFileUploadBucket;
    }()
  }]);

  return AppointmentService;
}();

export default new AppointmentService();